import {
  EditIcon,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  IconButton,
  IconButtonColorEnum,
  Tooltip,
  Typography,
} from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { REVIEW_INCIDENCE_TYPES } from '@/constants';
import { formatDateCustom } from '@/helpers/format-date';
import { useReport } from '@/stores/report-store';
import { EReviewIncidenceType } from '@/types';

type ReportComponentCommon = {
  reviewed_by_user_id?: string;
  review_incidence_type?: EReviewIncidenceType;
  review_incidence_note?: string;
  updated_at?: string | null;
  id?: string;
};

type ReportComponentProps<T extends ReportComponentCommon> = {
  item: T;
  type: 'program' | 'segment' | 'clip';
};

export function ReportComponent<T extends ReportComponentCommon>({
  item,
  type,
}: ReportComponentProps<T>) {
  const { t } = useTranslation();
  const { setReportEditData, setReportType, setReportedId, setReport } = useReport();
  const handleEditReport = () => {
    setReportEditData({
      reviewed_by_user_id: item.reviewed_by_user_id,
      review_incidence_type: item.review_incidence_type,
      review_incidence_note: item.review_incidence_note,
    });
    setReportType(type);
    setReportedId(item.id || '');
    setReport(true);
  };

  return (
    <div className="flex flex-col gap-1 rounded-md bg-feedback-warning-10 px-8 py-4">
      <Typography
        fontSize={FontSizeEnum.Xl}
        color={FontColorEnum.Dark10}
        weight={FontWeightEnum.Bold}
        className="mb-2"
      >
        {t('Incidencia')}
      </Typography>
      <hr />
      <div className="flex items-center justify-between">
        <Typography fontSize={FontSizeEnum.Xl} color={FontColorEnum.Dark10}>
          {
            REVIEW_INCIDENCE_TYPES.find(incidence => incidence.value === item.review_incidence_type)
              ?.label
          }
        </Typography>
        <Tooltip help={t('Editar')} grow>
          <IconButton color={IconButtonColorEnum.NONE_DEFAULT}>
            <EditIcon onClick={handleEditReport} />
          </IconButton>
        </Tooltip>
      </div>
      {item.updated_at && (
        <Typography fontSize={FontSizeEnum.Basic} color={FontColorEnum.Medium}>
          {formatDateCustom({ input: item.updated_at, format: 'dd/MM/yyyy HH:mm' })}
        </Typography>
      )}
      {item.review_incidence_note && (
        <Typography fontSize={FontSizeEnum.Body3} color={FontColorEnum.Dark10}>
          {item.review_incidence_note}
        </Typography>
      )}
    </div>
  );
}
